"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-campagnano": {
    "ee1cc14d": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "skipSearch": false
    }],
    "beneficio": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05d971ea": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "skipSearch": false
    }],
    "canale": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dd6f4bec": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "skipSearch": false
    }],
    "castagneto": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1eb583c0": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "skipSearch": false
    }],
    "cornuti": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee7f6fce": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "skipSearch": false
    }],
    "isola": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "001a4ccb": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "skipSearch": false
    }],
    "ticoli": [{
      "hkey": "4db2fcc9",
      "slug": "castel-campagnano",
      "name": "Castel Campagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;